import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import {
  UiGroupAssignedWithVariantsItemComponent,
  UiGroupSelectionItemComponent,
} from '@markant-platform/shared/authorizer/ui';
import { InvitationGroup } from '@markant-platform/authorizer/model';
import { IsSelectedGroupPipe } from './pipe/is-selected-group.pipe';

@Component({
  selector: 'markant-platform-organization-member-invitation-add-group',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoPipe,
    MarkantElementsModule,
    UiGroupAssignedWithVariantsItemComponent,
    UiGroupSelectionItemComponent,
    IsSelectedGroupPipe,
  ],
  templateUrl: './organization-member-invitation-add-group.component.html',
  styleUrl: './organization-member-invitation-add-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationMemberInvitationAddGroupComponent {
  @Input() invitationGroupsSelected: InvitationGroup[] = [];
  @Input() invitationGroups: InvitationGroup[] = [];

  @Output() clicked = new EventEmitter<InvitationGroup>();
}
